import { inject, Injectable } from "@angular/core";
import { ProgressMonitorResource } from "core/stages-client";

type ProgressInfo = stages.common.ProgressInfo;

@Injectable({ providedIn: "root" })
export class ProgressService {
	private readonly progressMonitorResource = inject(ProgressMonitorResource);

	async getJobProgress(
		operationType: string,
		workspaceId: string,
		pv: string,
		jobName: string,
		isPolling = false,
	): Promise<ProgressInfo> {
		if (isPolling) {
			this.progressMonitorResource.setHeadersForNextRequest({
				"Stages-Polling": "true",
			});
		}
		this.progressMonitorResource.setAdditionalHttpParamsForNextRequest({
			pv: pv,
		});
		return this.progressMonitorResource.getCurrentProgress(jobName, {
			operationType: operationType,
			workspaceId: workspaceId,
		});
	}

	async getBatchProgress(
		groupPrefix: string,
		workspaceId: string,
		pv: string,
		isPolling = false,
	): Promise<ProgressInfo> {
		if (isPolling) {
			this.progressMonitorResource.setHeadersForNextRequest({
				"Stages-Polling": "true",
			});
		}
		this.progressMonitorResource.setAdditionalHttpParamsForNextRequest({
			pv: pv,
		});
		return this.progressMonitorResource.getBatchProgress(groupPrefix, {
			workspaceId: workspaceId,
		});
	}

	async getLatestJob(operationTypes: string[], workspaceId: string, pv: string): Promise<ProgressInfo | null> {
		this.progressMonitorResource.setAdditionalHttpParamsForNextRequest({
			pv: pv,
		});
		return this.progressMonitorResource.getLatestJob({
			operationType: operationTypes,
			workspaceId: workspaceId,
		});
	}
}
